var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 13C12.75 12.5858 12.4142 12.25 12 12.25C11.5858 12.25 11.25 12.5858 11.25 13V17C11.25 17.4142 11.5858 17.75 12 17.75C12.4142 17.75 12.75 17.4142 12.75 17V13Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6061 12.2575C16.0161 12.3161 16.301 12.696 16.2425 13.1061L15.7425 16.6061C15.6839 17.0161 15.304 17.301 14.8939 17.2425C14.4839 17.1839 14.199 16.804 14.2575 16.3939L14.7575 12.8939C14.8161 12.4839 15.196 12.199 15.6061 12.2575Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24247 12.8939C9.18389 12.4839 8.80399 12.199 8.39394 12.2575C7.98389 12.3161 7.69896 12.696 7.75754 13.1061L8.25754 16.6061C8.31612 17.0161 8.69602 17.301 9.10607 17.2425C9.51612 17.1839 9.80104 16.804 9.74247 16.3939L9.24247 12.8939Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.25 3.75H14.7388C14.6125 2.34837 13.4345 1.25 12 1.25C10.5655 1.25 9.38752 2.34837 9.26121 3.75H5.75C4.36929 3.75 3.25 4.86929 3.25 6.25C3.25 7.07661 3.65118 7.80953 4.26946 8.26465L5.26644 20.2284C5.38521 21.6537 6.5767 22.75 8.00694 22.75H15.9931C17.4233 22.75 18.6148 21.6537 18.7336 20.2284L19.7306 8.26464C20.3488 7.80952 20.75 7.07661 20.75 6.25C20.75 4.86929 19.6307 3.75 18.25 3.75ZM12 2.75C12.6047 2.75 13.1092 3.17944 13.225 3.75H10.775C10.8908 3.17944 11.3953 2.75 12 2.75ZM18.1849 8.75H5.81511L6.76126 20.1038C6.81524 20.7517 7.35683 21.25 8.00694 21.25H15.9931C16.6432 21.25 17.1848 20.7517 17.2388 20.1038L18.1849 8.75ZM18.25 7.25C18.8023 7.25 19.25 6.80228 19.25 6.25C19.25 5.69772 18.8023 5.25 18.25 5.25H5.75C5.19772 5.25 4.75 5.69772 4.75 6.25C4.75 6.80228 5.19772 7.25 5.75 7.25H18.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash2);
export default __webpack_public_path__ + "static/media/trash-2.4186630a9bf8bda09975bd979d2d4ccb.svg";
export { ForwardRef as ReactComponent };